import type { ReactNode } from "react";

/**
 * The Evaluate header strip. `children` is the breadcrumb trail on detail
 * routes; the strip renders unconditionally so the layout is stable across
 * the list and detail routes.
 */
export function EvalsHeader({ children }: { children?: ReactNode }) {
  return (
    <div className="shrink-0 border-b border-border/60 bg-muted/15 px-4 py-2.5 sm:px-6">
      <div className="flex min-w-0 flex-col gap-3 sm:flex-row sm:items-center sm:gap-4">
        {children}
      </div>
    </div>
  );
}
